import { render, staticRenderFns } from "./IngredientsTable.vue?vue&type=template&id=5629289d&scoped=true&lang=pug"
import script from "./IngredientsTable.vue?vue&type=script&lang=js"
export * from "./IngredientsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5629289d",
  null
  
)

export default component.exports